/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable no-unused-expressions */

import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, Row } from "components/Grid";
import { Field, Form, Formik } from "formik";
import {
  GridColumnTitle,
  InputField,
  SelectField,
  MultiSelectField,
  Label,
} from "components/Form";
import {
  RowOrderFilter,
  CalendarContainer,
  MobileLabel,
  FilterSearchContainer,
  RowFilterIcon,
  FilterContainer,
  RowFilter,
  CheckBoxColumn,
  FilterColumn,
  ColIcon,
  RowOrderFilterMobile,
  DialogSelect,
  DialogCancel,
  DialogConfirm,
  FilterLabel,
  TooltipCard,
  TooltipBox,
  TooltipText
} from "./styles";

import { DateRangePicker } from "components";
import { Button } from "components/index";
import Icon from "components/Icon";
import { GlobalAuthContext } from "store/context";
import Checkbox from "components/Form/CheckBox";
import CustomFilterModal from "flows/broking/pages/customFilterModal/index";
import DialogComponent from "components/Dialog/index";
import * as Yup from 'yup';
import MessageCenter from "utils/src/message-center";
import MasksHelper from 'utils/src/masks';

const ListHeader = (props) => {
  const masks = new MasksHelper();
  const mc = new MessageCenter();
  
  const initialValues = {
    id: '',
    nmFilter: "",
    nmClient: "",
    orderClient: 0,
    nmObligor: "",
    orderObligor: 0,
    idBroker: "",
    likelihoodOfBinding: "",
    idProduct: "",
    orderBroker: 0,
    idStatus: "",
    orderStatus: 0,
    dtResponseBy: {
      from: null,
      to: null,
    },
    orderResponseBy: 0,
    dsReferenceNumber: "",
    leadingOffice: "",
    orderReferenceNumber: 0,
    estimatedBindingDate: '',
    estimatedYear1DpBrokerage: '',
    requestLimit: '',
    idAction: "",
    orderOffice: 0,
    hideInactiveTransactions: false,
    hideExecutedTransactions: false
  };

  const [orderArrows, setOrderArrows] = useState({
    client: false,
    obligor: false,
    broker: false,
    status: false,
    responseBy: false,
    reference: false,
    office: false,
  });

  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null
  });
  
  const [filterSelected, setFilterSelected] = useState(initialValues);
  const [download, setDownload] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [isAbleEdit, setIsAbleEdit] = useState(false);
  const [isAbleDelete, setIsAbleDelete] = useState(false);
  const [isAbleCreate, setIsAbleCreate] = useState(false);
  const [typeDialog, setTypeDialog] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
    
  const formik = useRef(null);
  const authContext = useContext(GlobalAuthContext);

  const isClient = authContext.enumProfile === 1;

  useEffect(() => {
    props.formikRef(formik);
  }, []);

  useEffect(() => {
    if (props.defaultFilter) {
      setFilterSelected(props.defaultFilter)
      if (props.defaultFilter.filterName != 'DEFAULT') {
        formik.current?.setFieldValue("filtersList", props.defaultFilter.id);
      } else {
        formik.current?.setFieldValue("filtersList", 0);
      }
    }
  }, [props.defaultFilter]);

  const showRangeDate = () => {
    const from = formik.current?.values?.dtResponseBy?.from
      ? new Date(formik.current.values.dtResponseBy.from).toLocaleDateString("en-GB")
      : "";
    const to = formik.current?.values?.dtResponseBy?.to
      ? new Date(formik.current.values.dtResponseBy.to).toLocaleDateString("en-GB")
      : "";

    if (!from && !to) {
      return "";
    }

    return `${from} - ${to}`;
  };

  function resetFormikOrderParams(formikProps) {
    formikProps?.setFieldValue("orderClient", 0);
    formikProps?.setFieldValue("orderObligor", 0);
    formikProps?.setFieldValue("orderBroker", 0);
    formikProps?.setFieldValue("orderStatus", 0);
    formikProps?.setFieldValue("orderResponseBy", 0);
    formikProps?.setFieldValue("orderReferenceNumber", 0);
    formikProps?.setFieldValue("orderOffice", 0);
  }

  const deleteFilter = () => {
    setShowFilter(false)
    if (filterSelected.filterName) {
      setTypeDialog('deleteFilter');
      setDialog({
        visible: true,
        title: 'REMOVE FILTER',
        icon: 'exclamation',
        args: null
      })
    }
  }

  const handleFilter = (value) => {
    if (isAbleEdit) {
      if (!value.nmFilter || value.nmFilter === 'DEFAULT' || value.nmFilter === 'default') {
        return mc.error("An error happened, incorrect value for filter name.");
      }
      setIsAbleEdit(false)
      return props.editCustomFilter(value)
    }
    if (isAbleCreate) {
      if (!value.nmFilter || value.nmFilter === 'DEFAULT' || value.nmFilter === 'default') {
        return mc.error("An error happened, incorrect value for filter name.");
      }
      setIsAbleCreate(false)
      return props.createCustomFilter(value)
    }
    if (!isAbleCreate || !isAbleEdit) {
      setShowFilter(false)
      return props.updateFilter(value);
    }
  }

  const controlFilter = (action) => {
    if (action === 'edit' && filterSelected.filterName && filterSelected.filterName != 'DEFAULT') {
      setIsAbleEdit(!isAbleEdit)
      setIsAbleDelete(false)
      setIsAbleCreate(false)
    }
    if (action === 'create') {
      setIsAbleEdit(false)
      setIsAbleDelete(false)
      setIsAbleCreate(!isAbleCreate)
    }
    if (action === 'delete') {
      if (filterSelected.filterName === 'DEFAULT') return;
      deleteFilter()
    }
  }

  useEffect(() => {
    props.onShowFilter(showFilter)
  }, [showFilter])

  const OrderFilter = (formikProps) => {
    return (
      <Row style={{ width: '100%' }}>
        <Col className="pl-4 mb-2 mb-md-0">
          <GridColumnTitle
            style={{ cursor: "pointer" }}
            onMouseOut={() => {
              let f = { ...orderArrows };
              f.reference = false;
              setOrderArrows(f);
            }}
            onMouseOver={() => {
              let f = { ...orderArrows };
              f.reference = true;
              setOrderArrows(f);
            }}
            onClick={() => {
              const orderType =
                formikProps?.values?.orderReferenceNumber === 2
                  ? 0
                  : formikProps?.values?.orderReferenceNumber + 1;
              resetFormikOrderParams(formikProps);
              formikProps?.setFieldValue(
                "orderReferenceNumber",
                orderType
              );
              formikProps.handleSubmit();
            }}
          >
            REFERENCE{" "}
            {formikProps?.values?.orderReferenceNumber !== 0 ? (
              <Icon
                name={
                  formikProps?.values?.orderReferenceNumber === 2
                    ? "arrowdown"
                    : "arrowup"
                }
              />
            ) : orderArrows.reference ? (
              <Icon name={"arrowup"} />
            ) : (
              false
            )}
          </GridColumnTitle>
        </Col>
        {isClient
          ? <></>
          : (
            <Col className="pl-0 mb-2 mb-md-0">
              <GridColumnTitle
                style={{ cursor: "pointer" }}
                onMouseOut={() => {
                  let f = { ...orderArrows };
                  f.client = false;
                  setOrderArrows(f);
                }}
                onMouseOver={() => {
                  let f = { ...orderArrows };
                  f.client = true;
                  setOrderArrows(f);
                }}
                onClick={() => {
                  const orderType =
                    formikProps?.values?.orderClient == 2
                      ? 0
                      : formikProps?.values?.orderClient + 1;
                  resetFormikOrderParams(formikProps);
                  formikProps?.setFieldValue("orderClient", orderType);
                  formikProps.handleSubmit();
                }}
              >
                CLIENT{" "}
                {formikProps?.values?.orderClient != 0 ? (
                  <Icon
                    name={
                      formikProps?.values?.orderClient == 2
                        ? "arrowdown"
                        : "arrowup"
                    }
                  />
                ) : orderArrows.client ? (
                  <Icon name={"arrowup"} />
                ) : (
                  false
                )}
              </GridColumnTitle>
            </Col>
          )}
        <Col className="pl-0 mb-2 mb-md-0">
          <GridColumnTitle
            style={{ cursor: "pointer" }}
            onMouseOut={() => {
              let f = { ...orderArrows };
              f.obligor = false;
              setOrderArrows(f);
            }}
            onMouseOver={() => {
              let f = { ...orderArrows };
              f.obligor = true;
              setOrderArrows(f);
            }}
            onClick={() => {
              const orderType =
                formikProps?.values?.orderObligor === 2
                  ? 0
                  : formikProps?.values?.orderObligor + 1;
              resetFormikOrderParams(formikProps);
              formikProps?.setFieldValue("orderObligor", orderType);
              formikProps.handleSubmit();
            }}
          >
            MAIN PARTY{" "}
            {formikProps?.values?.orderObligor !== 0 ? (
              <Icon
                name={
                  formikProps?.values?.orderObligor === 2
                    ? "arrowdown"
                    : "arrowup"
                }
              />
            ) : orderArrows.obligor ? (
              <Icon name={"arrowup"} />
            ) : (
              false
            )}
          </GridColumnTitle>
        </Col>
        <Col className="pl-0 mb-2 mb-md-0">
          <GridColumnTitle
            style={{ cursor: "pointer" }}
            onMouseOut={() => {
              let f = { ...orderArrows };
              f.obligor = false;
              setOrderArrows(f);
            }}
            onMouseOver={() => {
              let f = { ...orderArrows };
              f.obligor = true;
              setOrderArrows(f);
            }}
            onClick={() => {
              const orderType =
                formikProps?.values?.orderObligor === 2
                  ? 0
                  : formikProps?.values?.orderObligor + 1;
              resetFormikOrderParams(formikProps);
              formikProps?.setFieldValue("orderObligor", orderType);
              formikProps.handleSubmit();
            }}
          >
            PRODUCT{" "}
            {formikProps?.values?.orderObligor !== 0 ? (
              <Icon
                name={
                  formikProps?.values?.orderObligor === 2
                    ? "arrowdown"
                    : "arrowup"
                }
              />
            ) : orderArrows.obligor ? (
              <Icon name={"arrowup"} />
            ) : (
              false
            )}
          </GridColumnTitle>
        </Col>
        <Col className="pl-0 mb-2 mb-md-0">
          <GridColumnTitle
            style={{ cursor: "pointer" }}
            onMouseOut={() => {
              let f = { ...orderArrows };
              f.broker = false;
              setOrderArrows(f);
            }}
            onMouseOver={() => {
              let f = { ...orderArrows };
              f.broker = true;
              setOrderArrows(f);
            }}
            onClick={() => {
              const orderType =
                formikProps?.values?.orderBroker === 2
                  ? 0
                  : formikProps?.values?.orderBroker + 1;
              resetFormikOrderParams(formikProps);
              formikProps?.setFieldValue("orderBroker", orderType);
              formikProps.handleSubmit();
            }}
          >
            BROKER{" "}
            {formikProps?.values?.orderBroker !== 0 ? (
              <Icon
                name={
                  formikProps?.values?.orderBroker === 2
                    ? "arrowdown"
                    : "arrowup"
                }
              />
            ) : orderArrows.broker ? (
              <Icon name={"arrowup"} />
            ) : (
              false
            )}
          </GridColumnTitle>
        </Col>

        <Col className="pl-0 mb-2 mb-md-0">
          <GridColumnTitle
            style={{ cursor: "pointer" }}
            onMouseOut={() => {
              let f = { ...orderArrows };
              f.responseBy = false;
              setOrderArrows(f);
            }}
            onMouseOver={() => {
              let f = { ...orderArrows };
              f.responseBy = true;
              setOrderArrows(f);
            }}
            onClick={() => {
              const orderType =
                formikProps?.values?.orderResponseBy === 2
                  ? 0
                  : formikProps?.values?.orderResponseBy + 1;
              resetFormikOrderParams(formikProps);
              formikProps?.setFieldValue("orderResponseBy", orderType);
              formikProps.handleSubmit();
            }}
          >
            CREATE DATE{" "}
            {formikProps?.values?.orderResponseBy !== 0 ? (
              <Icon
                name={
                  formikProps?.values?.orderResponseBy === 2
                    ? "arrowdown"
                    : "arrowup"
                }
              />
            ) : orderArrows.responseBy ? (
              <Icon name={"arrowup"} />
            ) : (
              false
            )}
          </GridColumnTitle>
        </Col>
        {isClient
          ? <></>
          : (
            <Col className="pl-0 mb-2 mb-md-0">
              <GridColumnTitle
                style={{ cursor: "pointer" }}
                onMouseOut={() => {
                  let f = { ...orderArrows };
                  f.office = false;
                  setOrderArrows(f);
                }}
                onMouseOver={() => {
                  let f = { ...orderArrows };
                  f.office = true;
                  setOrderArrows(f);
                }}
                onClick={() => {
                  const orderType =
                    formikProps?.values?.orderOffice === 2
                      ? 0
                      : formikProps?.values?.orderOffice + 1;
                  resetFormikOrderParams(formikProps);
                  formikProps?.setFieldValue("orderOffice", orderType);
                  formikProps.handleSubmit();
                }}
              >
                OFFICE{" "}
                {formikProps?.values?.orderOffice !== 0 ? (
                  <Icon
                    name={
                      formikProps?.values?.orderOffice === 2
                        ? "arrowdown"
                        : "arrowup"
                    }
                  />
                ) : orderArrows.office ? (
                  <Icon name={"arrowup"} />
                ) : (
                  false
                )}
              </GridColumnTitle>
            </Col>
          )}
        <Col className="pl-0 mb-2 mb-md-0">
          <GridColumnTitle style={{ cursor: "not-allowed" }}>
            STATUS
          </GridColumnTitle>
        </Col>
        <Col style={{ textAlign: "end" }}>
          <GridColumnTitle style={{ paddingRight: "50px" }}>ACTION</GridColumnTitle>
        </Col>
      </Row>
    );
  };

  const actionOptions = [
    { label: "To Assign", value: 1 },
    { label: "To Approve", value: 2 },
  ];

  return (
    <Formik
      onSubmit={(values) => {
        setShowFilter(false)
        props.updateFilter(values);
      }}
      initialValues={initialValues}
      innerRef={ref => {
        formik.current = ref;
        props.formikRef(formik)
      }}
      enableReinitialization={true}
    >
      {(formikProps) => {
        return (
          <Form>
            <RowFilterIcon>
              <FilterContainer
                className={showFilter ? "filter-open" : "filter-close"}
              >
                <Row>
                  <Col
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      padding: "5px 0 5px 0",
                    }}
                  >
                    <Icon
                      name="close"
                      className="icon-close"
                      onClick={() => setShowFilter(false)}
                    />
                  </Col>
                </Row>
                <RowOrderFilterMobile>
                  <MobileLabel style={{ paddingBottom: '10px' }}>ORDER</MobileLabel>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {OrderFilter(formikProps)}
                  </div>
                </RowOrderFilterMobile>
                <hr className="d-md-none mb-3" />
                <FilterSearchContainer>
                  <Row>
                    <Col>
                      <MobileLabel>{filterSelected.filterName ? filterSelected.filterName : 'FILTER'}</MobileLabel>
                    </Col>

                    <Col>
                      <Row>
                        <ColIcon>
                          <Icon
                            name="edit"
                            onClick={() => {
                              controlFilter('edit')
                            }}
                            disabled={true}
                          />
                        </ColIcon>
                        <ColIcon>
                          <Icon
                            name="trash"
                            onClick={() => {
                              formikProps.setValues({
                                id: '',
                                nmFilter: '',
                                nmClient: '',
                                orderClient: '',
                                nmObligor: '',
                                orderObligor: '',
                                idProduct: '',
                                idBroker: '',
                                likelihoodOfBinding: '',
                                orderBroker: '',
                                idStatus: '',
                                orderStatus: '',
                                dtResponseBy: {
                                  from: '',
                                  to: '',
                                },
                                orderResponseBy: '',
                                dsReferenceNumber: '',
                                estimatedBindingDate: '',
                                estimatedYear1DpBrokerage: '',
                                requestLimit: '',
                                orderReferenceNumber: '',
                                idAction: '',
                                orderOffice: '',
                                leadingOffice: '',
                                hideInactiveTransactions: '',
                                hideExecutedTransactions: ''
                              })
                              controlFilter('delete')
                            }}
                          />
                        </ColIcon>
                        <ColIcon>
                          <Icon
                            name="add-grey"
                            onClick={() => {
                              formikProps.setValues({
                                id: '',
                                nmFilter: '',
                                nmClient: '',
                                orderClient: '',
                                nmObligor: '',
                                idProduct: '',
                                orderObligor: '',
                                idBroker: '',
                                orderBroker: '',
                                idStatus: '',
                                orderStatus: '',
                                dtResponseBy: {
                                  from: '',
                                  to: '',
                                },
                                orderResponseBy: '',
                                dsReferenceNumber: '',
                                estimatedBindingDate: '',
                                estimatedYear1DpBrokerage: '',
                                requestLimit: '',
                                orderReferenceNumber: '',
                                idAction: '',
                                orderOffice: '',
                                leadingOffice: '',
                                likelihoodOfBinding: '',
                                hideInactiveTransactions: '',
                                hideExecutedTransactions: ''
                              })
                              controlFilter('create')
                            }}
                          />
                        </ColIcon>
                      </Row>

                    </Col>
                  </Row>

                  <RowFilter>
                    {isAbleEdit || isAbleCreate ?
                      <FilterColumn>
                        <Field
                          name="nmFilter"
                          placeholder="Filter Name"
                          value={formikProps.values.nmFilter}
                          component={InputField}
                          type="text"
                          onChange={(e) => {
                            formikProps?.setFieldValue("nmFilter", e);
                          }}
                          validation={false}
                          list={true}
                        />
                      </FilterColumn>
                      :
                      <FilterColumn>
                        <Field
                          name="filtersList"
                          label="My filters"
                          isRequired
                          options={props.options}
                          onChange={(e) => {
                            let office = {};
                            if (!Array.isArray(props.filtersList[e].filterArgs.leadingOffice) && props.filtersList[e].filterArgs.leadingOffice) {
                              office = props.filtersList[e].filterArgs.leadingOffice.trim();
                              office = props.offices.find(officeLeading => officeLeading.label == office);
                            } else {
                              office.value = '';
                            }
                            setFilterSelected(props.filtersList[e])
                            formikProps.setValues({
                              id: props.filtersList[e].id,
                              nmFilter: props.filtersList[e].filterName,
                              nmClient: props.filtersList[e].filterArgs.nmClient,
                              orderClient: props.filtersList[e].filterArgs.orderClient,
                              nmObligor: props.filtersList[e].filterArgs.nmObligor,
                              idProduct: props.filtersList[e].filterArgs.idProduct,
                              orderObligor: props.filtersList[e].filterArgs.orderObligor,
                              idBroker: props.filtersList[e].filterArgs.idBroker,
                              likelihoodOfBinding: props.filterList[e].filterArgs.likelihoodOfBinding,
                              orderBroker: props.filtersList[e].filterArgs.orderBroker,
                              idStatus: props.filtersList[e].filterArgs.idStatus,
                              orderStatus: props.filtersList[e].filterArgs.orderStatus,
                              dtResponseBy: {
                                from: props.filtersList[e].filterArgs.dtResponseBy.from,
                                to: props.filtersList[e].filterArgs.dtResponseBy.to,
                              },
                              orderResponseBy: props.filtersList[e].filterArgs.orderResponseBy,
                              dsReferenceNumber: props.filtersList[e].filterArgs.dsReferenceNumber,
                              estimatedBindingDate: props.filtersList[e].filterArgs.estimatedBindingDate,
                              estimatedYear1DpBrokerage: props.filtersList[e].filterArgs.estimatedBindingDate,
                              requestLimit: props.filterList[e].filterArgs.requestLimit,
                              orderReferenceNumber: props.filtersList[e].filterArgs.orderReferenceNumber,
                              idAction: props.filtersList[e].filterArgs.idAction,
                              orderOffice: props.filtersList[e].filterArgs.orderOffice,
                              leadingOffice: props.filtersList[e].filterArgs.leadingOffice && Array.isArray(props.filtersList[e].filterArgs.leadingOffice) ? props.filtersList[e].filterArgs.leadingOffice : office?.value ? [office?.value] : '',
                              hideInactiveTransactions: props.filtersList[e].filterArgs.hideInactiveTransactions,
                              hideExecutedTransactions: props.filtersList[e].filterArgs.hideExecutedTransactions
                            })
                            formikProps?.setFieldValue("filtersList", props.options[e].value);
                          }}
                          component={SelectField}
                        />
                      </FilterColumn>
                    }
                  </RowFilter>

                  <RowFilter>
                    <CheckBoxColumn>
                      <Label>
                        <Checkbox
                          checked={formikProps.values.dsReferenceNumber?.length}
                          onChange={() =>
                            formik.current?.setFieldValue(
                              "dsReferenceNumber",
                              ""
                            )
                          }
                        />
                      </Label>
                    </CheckBoxColumn>
                    <FilterColumn>
                      <Field
                        name="dsReferenceNumber"
                        placeholder="Reference Number"
                        component={InputField}
                        type="text"
                        validation={false}
                        value={formikProps.values.dsReferenceNumber}
                        onChange={formikProps.handleChange}
                        filter={true}
                        onPressEnter={() => {
                          formikProps.submitForm();
                        }}
                      />
                    </FilterColumn>
                  </RowFilter>

                  <RowFilter>
                    <CheckBoxColumn>
                      <Label>
                        <Checkbox
                          checked={formikProps.values.leadingOffice?.length}
                          onChange={() =>
                            formik.current?.setFieldValue(
                              "leadingOffice",
                              ""
                            )
                          }
                        />
                      </Label>
                    </CheckBoxColumn>
                    <FilterColumn>
                      <Field
                        name="leadingOffice"
                        placeholder="Leading Office"
                        component={MultiSelectField}
                        validation={false}
                        options={props.offices}
                        value={formikProps.values.leadingOffice}
                        filter={true}
                        onChange={(e) => {
                          if(!e.length){
                            formikProps?.setFieldValue("leadingOffice", '');
                          }else{
                            formikProps?.setFieldValue("leadingOffice", e);
                          }
                        }}
                        format={(value) => {
                          const selectedOffices = props.offices.filter(option => value.includes(option.value))
                          return selectedOffices.map(item => item.label).join(', ')
                        }}
                        onPressEnter={() => {
                          formikProps.submitForm();
                        }}
                      />
                    </FilterColumn>
                  </RowFilter>

                  {isClient
                    ? <></>
                    : (
                      <RowFilter>
                        <CheckBoxColumn>
                          <Label>
                            <Checkbox
                              checked={formikProps.values.nmClient?.length}
                              onChange={() =>
                                formik.current?.setFieldValue("nmClient", "")
                              }
                            />
                          </Label>
                        </CheckBoxColumn>
                        <FilterColumn>
                          <Field
                            name="nmClient"
                            placeholder="Client"
                            value={formikProps.values.nmClient}
                            component={InputField}
                            type="text"
                            onChange={(e) => {
                              formikProps?.setFieldValue("nmClient", e);
                            }}
                            validation={false}
                            list={true}
                            onPressEnter={() => {
                              formikProps.submitForm();
                            }}
                          />
                        </FilterColumn>
                      </RowFilter>
                    )}
                  <RowFilter>
                    <CheckBoxColumn>
                      <Label>
                        <Checkbox
                          checked={formikProps.values.nmObligor?.length}
                          onChange={() =>
                            formik.current?.setFieldValue("nmObligor", "")
                          }
                        />
                      </Label>
                    </CheckBoxColumn>
                    <FilterColumn>
                      <Field
                        name="nmObligor"
                        placeholder="Main Party"
                        component={InputField}
                        type="text"
                        validation={false}
                        value={formikProps.values.nmObligor}
                        onChange={(e) => {
                          formikProps?.setFieldValue("nmObligor", e);
                        }}
                        list={true}
                        onPressEnter={() => {
                          formikProps.submitForm();
                        }}
                      />
                    </FilterColumn>
                  </RowFilter>
                
                  <RowFilter>
                    <CheckBoxColumn>
                      <Label>
                        <Checkbox
                          checked={formikProps.values.idProduct?.length}
                          onChange={() =>
                            formik.current?.setFieldValue("idProduct", "")
                          }
                        />
                      </Label>
                    </CheckBoxColumn>
                    <FilterColumn>
                      <Field
                        name="idProduct"
                        placeholder="Products"
                        type="text"
                        component={MultiSelectField}
                        options={props.products || []}
                        validation={false}
                        value={formikProps.values.idProduct}
                        onChange={(e) => {
                          if(!e.length){
                            formikProps?.setFieldValue("idProduct", '');
                          }else{
                            formikProps?.setFieldValue("idProduct", e);
                          }
                        }}
                        format={(value) => {
                          const selectedProduct = props.products.filter(option => value.includes(option.value))
                          return selectedProduct.map(item => item.label).join(', ')
                        }}
                        filter={true}
                      />
                    </FilterColumn>
                  </RowFilter>

                  <RowFilter>
                    <CheckBoxColumn>
                      <Label>
                        <Checkbox
                          checked={formikProps.values.idBroker?.length}
                          onChange={() =>
                            formik.current?.setFieldValue("idBroker", "")
                          }
                        />
                      </Label>
                    </CheckBoxColumn>
                    <FilterColumn>
                      <Field
                        name="idBroker"
                        placeholder="Broker"
                        type="text"
                        component={MultiSelectField}
                        options={props.broker || []}
                        validation={false}
                        value={formikProps.values.idBroker}
                        onChange={(e) => {
                          if(!e.length){
                            formikProps?.setFieldValue("idBroker", '');
                          }else{
                            formikProps?.setFieldValue("idBroker", e);
                          }
                        }}
                        format={(value) => {
                          const selectedBrokers = props.broker.filter(option => value.includes(option.value))
                          return selectedBrokers.map(item => item.label).join(', ')
                        }}
                        filter={true}
                      />
                    </FilterColumn>
                  </RowFilter>

                  <RowFilter>
                    <CheckBoxColumn>
                      <Label>
                        <Checkbox
                          checked={formikProps.values.dtResponseBy.from}
                          onChange={() =>
                            formik.current?.setFieldValue("dtResponseBy", {
                              from: null,
                              to: null,
                            })
                          }
                        />
                      </Label>
                    </CheckBoxColumn>
                    <FilterColumn>
                      <Field
                        name="dtResponseBy"
                        placeholder="Enquiry Received Date"
                        isCalendar
                        component={InputField}
                        rightIcon="calendar"
                        rightIconClick={() => {
                          setShowCalendar(!showCalendar);
                        }}
                        validation={false}
                        customValue={showRangeDate()}
                        type="text"
                        readOnly
                      />
                    </FilterColumn>
                  </RowFilter>
                  {showCalendar && (
                    <CalendarContainer>
                      <DateRangePicker
                        initialRange={{
                          from: formikProps.values?.dtResponseBy?.from,
                          to: formikProps.values?.dtResponseBy?.to,
                        }}
                        onChange={(range) => {
                          formikProps?.setFieldValue(
                            "dtResponseBy.from",
                            range.from
                          );
                          formikProps?.setFieldValue(
                            "dtResponseBy.to",
                            range.to
                          );

                          if (range.from && range.to) {
                            setShowCalendar(false);
                            props.updateFilter({
                              dtResponseByFrom: new Date(
                                range.from
                              ).toLocaleDateString("en-US"),
                              dtResponseByTo: new Date(
                                range.to
                              ).toLocaleDateString("en-US"),
                            });
                          }
                        }}
                      />
                    </CalendarContainer>
                  )}

                  <RowFilter>
                    <CheckBoxColumn>
                      <Label>
                        <Checkbox
                          checked={formikProps.values.estimatedBindingDate?.length}
                          onChange={() =>
                            formik.current?.setFieldValue(
                              "estimatedBindingDate",
                              ""
                            )
                          }
                        />
                      </Label>
                    </CheckBoxColumn>
                    <FilterColumn>
                      <Field
                        name="estimatedBindingDate"
                        placeholder="Estimated Binding Date"
                        component={InputField}
                        type="text"
                        validation={false}
                        value={formikProps.values.estimatedBindingDate}
                        onChange={(value) => {
                          formikProps.handleChange(value.replace(/,/g, ""));
                        }}
                        mask={masks.getMonthYearMask()}
                        filter={true}
                        onPressEnter={() => {
                          formikProps.submitForm();
                        }}
                      />
                    </FilterColumn>
                  </RowFilter>

                  <RowFilter>
                    <CheckBoxColumn>
                      <Label>
                        <Checkbox
                          checked={formikProps.values.estimatedYear1DpBrokerage?.length}
                          onChange={() =>
                            formik.current?.setFieldValue(
                              "estimatedYear1DpBrokerage",
                              ""
                            )
                          }
                        />
                      </Label>
                    </CheckBoxColumn>
                    <FilterColumn>
                      <Field
                        type="text"
                        filter={true}
                        validation={false}
                        component={InputField}
                        name="estimatedYear1DpBrokerage"
                        placeholder="Estimated Year 1 DP Brokerage"
                        value={formikProps.values.estimatedYear1DpBrokerage}
                        mask={masks.getMask("currency", authContext.region, 2, 12, 999999999999.99, 0.0)}
                        onChange={(value) => {
                          formikProps.handleChange(value.replace(/,/g, ""));
                        }}
                        onPressEnter={formikProps.submitForm}
                      />
                    </FilterColumn>
                  </RowFilter>

                  <RowFilter>
                    <CheckBoxColumn>
                      <Label>
                        <Checkbox
                          checked={formikProps.values.likelihoodOfBinding?.length}
                          onChange={() =>
                            formik.current?.setFieldValue("likelihoodOfBinding", "")
                          }
                        />
                      </Label>
                    </CheckBoxColumn>
                    <FilterColumn>
                      <Field
                        type="text"
                        validation={false}
                        component={MultiSelectField}
                        name="likelihoodOfBinding"
                        placeholder="Likelihood Of Binding"
                        options={props.likelihoodOptions || []}
                        value={formikProps.values.likelihoodOfBinding}                        
                        onChange={(e) => {
                          if(!e.length){
                            formikProps?.setFieldValue("likelihoodOfBinding", "");
                          }else{
                            formikProps?.setFieldValue("likelihoodOfBinding", e);
                          }
                        }}
                        format={(value) => {
                          const selectedOptions = props.likelihoodOptions?.filter(option => value.includes(option.value))
                          return selectedOptions?.map(item => item.label).join(", ")
                        }}
                        filter={true}
                      />
                    </FilterColumn>
                  </RowFilter>

                  {/* <RowFilter>
                    <CheckBoxColumn>
                      <Label>
                        <Checkbox
                          checked={formikProps.values.requestLimit?.length}
                          onChange={() =>
                            formik.current?.setFieldValue(
                              "requestLimit",
                              ""
                            )
                          }
                        />
                      </Label>
                    </CheckBoxColumn>
                    <FilterColumn>
                      <Field
                        type="text"
                        filter={true}
                        validation={false}
                        component={InputField}
                        name="requestLimit"
                        placeholder="Request Limit"
                        value={formikProps.values.requestLimit}
                        mask={masks.getMask("currency", authContext.region)}
                        onChange={formikProps.handleChange}
                        onPressEnter={formikProps.submitForm}
                      />
                    </FilterColumn>
                  </RowFilter> */}
                  
                  <RowFilter>
                    <CheckBoxColumn>
                      <Label>
                        <Checkbox
                          checked={formikProps.values.idStatus?.length}
                          onChange={() =>
                            formik.current?.setFieldValue("idStatus", "")
                          }
                        />
                      </Label>
                    </CheckBoxColumn>
                    <FilterColumn>
                      <Field
                        name="idStatus"
                        placeholder="Status"
                        component={MultiSelectField}
                        options={props.status || []}
                        validation={false}
                        value={formikProps.values.idStatus}
                        filter={true}
                        onChange={(e) => {
                          if(!e.length){
                            formikProps?.setFieldValue("idStatus", '');
                          }else{
                            formikProps?.setFieldValue("idStatus", e);
                          }
                        }}
                        format={(value) => {
                          const selectedStatus = props.status.filter(option => value.includes(option.value))
                          return selectedStatus.map(item => item.label).join(', ')
                        }}
                        corDiferente={false}
                      />
                    </FilterColumn>
                  </RowFilter>

                  {isClient ? (
                    <></>
                  ) : (
                    <RowFilter>
                      <CheckBoxColumn>
                        <Label>
                          <Checkbox
                            checked={formikProps.values.idAction?.length}
                            onChange={() =>
                              formik.current?.setFieldValue("idAction", "")
                            }
                          />
                        </Label>
                      </CheckBoxColumn>
                      <FilterColumn>
                        <Field
                          name="idAction"
                          placeholder="Actions"
                          component={MultiSelectField}
                          options={actionOptions}
                          validation={false}
                          value={formikProps.values.idAction}
                          filter={true}
                          onChange={(e) => {
                            if(!e.length){
                              formikProps?.setFieldValue("idAction", '');
                            }else{
                              formikProps?.setFieldValue("idAction", e);
                            }
                          }}
                          corDiferente={false}
                          format={(value) => {
                            const selectedActions = actionOptions.filter(option => value.includes(option.value))
                            return selectedActions.map(item => item.label).join(', ')
                          }}
                        />
                      </FilterColumn>
                    </RowFilter>
                  )}
                  <RowFilter>
                    <CheckBoxColumn>
                      <Label>
                        <Checkbox
                          checked={formikProps.values.hideInactiveTransactions}
                          onChange={() =>
                            formik.current?.setFieldValue("hideInactiveTransactions", !formikProps.values.hideInactiveTransactions)
                          }
                        />
                      </Label>
                    </CheckBoxColumn>
                    <Label fontSize={14}>
                      Hide Inactive Transactions
                    </Label>
                  </RowFilter>

                  <RowFilter>
                    <CheckBoxColumn>
                      <Label>
                        <Checkbox
                          checked={formikProps.values.hideExecutedTransactions}
                          onChange={() => formik.current?.setFieldValue('hideExecutedTransactions', !formikProps.values.hideExecutedTransactions)}
                        />
                      </Label>
                    </CheckBoxColumn>
                    <FilterColumn style={{ paddingLeft: "10px" }}>
                      <Label fontSize={14}>Hide Executed Transactions</Label>
                    </FilterColumn>
                  </RowFilter>


                </FilterSearchContainer>

                <Row
                  align="center"
                  className="apply-button-container"
                >
                  <Col>
                    <Button
                      primary
                      type="button"
                      id="btnFilter"
                      style={{ textAlign: "center" }}
                      onClick={(e) => {
                        handleFilter(formikProps.values)
                      }}
                    >
                      {isAbleEdit || isAbleCreate ? 'Save' : 'Apply'}
                    </Button>
                  </Col>
                </Row>
              </FilterContainer>

              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <FilterLabel>
                  {filterSelected.filterName ? `FILTER: ${filterSelected.filterName}` : ''}
                </FilterLabel>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Icon
                    name="exportExcel"
                    title="Export Excel"
                    onClick={() => props.handleExportQuotes()}
                  />
                  <TooltipCard>
                    <TooltipText>
                      <ColIcon>
                        <Icon
                          name="filter"
                          onClick={() => setShowFilter(!showFilter)}
                        />
                      </ColIcon>
                    </TooltipText>
                    <TooltipBox>
                      {props.iconTooltips[585]}
                    </TooltipBox>
                  </TooltipCard>
                  <TooltipCard>
                    <TooltipText>
                      <ColIcon>
                        <Icon
                          name="filterCan"
                          onClick={(e) => {
                            setFilterSelected(props.defaultFilter)
                            props.requestCustomFilterList('reset')
                            formikProps.resetForm(initialValues);
                            formikProps.submitForm(initialValues);
                          }}
                        />
                      </ColIcon>
                    </TooltipText>
                    <TooltipBox>
                      {props.iconTooltips[586]}
                    </TooltipBox>
                  </TooltipCard>

                </div>
              </div>
            </RowFilterIcon>

            <DialogComponent icon={dialog.icon} title={dialog.title}  show={dialog.visible} setDialog={setDialog}>
              {typeDialog === 'deleteFilter' &&
                <>
                  <DialogCancel onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setDialog({ visible: false, title: null, icon: null, args: null })
                  }}>
                    Cancel
                  </DialogCancel>
                  <DialogConfirm onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    filterSelected.filterName = '';
                    formikProps.resetForm(initialValues);
                    formikProps.submitForm(initialValues);
                    props.deleteCustomFilter(filterSelected);
                    setDialog({ visible: false, title: null, icon: null, args: null })
                  }}>
                    Confirm
                  </DialogConfirm>
                </>
              }
            </DialogComponent>
          </Form >
        );
      }}
    </Formik >
  );
};

export default ListHeader;
